import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { supportedLocales, normalizeLocale } from '@/config/locales';
const supportedLanguagesArray = supportedLocales.map(language => language.code);

export interface LanguageState {
  language: string;
}

const initialState: LanguageState = {
  language: 'en',
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string | string[]>) => {
      const languages = action.payload;

      if (typeof languages === 'string') {
        // Only a locale we actually ship may reach consumers: an unsupported
        // code (e.g. 'pt-BR') would leave `t()` falling back silently and the
        // RTL/direction sync keyed off an unknown value.
        state.language = normalizeLocale(languages) ?? 'en';
      } else if (Array.isArray(languages)) {
        // The inner `find` used to return `sl`/null (truthy on the first
        // element regardless of match), so the outer find short-circuited on
        // the first supported language. A membership check is all that is
        // needed: pick the first payload entry that IS a supported language.
        state.language = languages.map(normalizeLocale).find(Boolean) || 'en';
      } else {
        state.language = 'en';
      }
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export const selectCurrentLanguage = (state: any) => state.language.language;
export const selectSupportedLanguages = () => supportedLanguagesArray;

export default languageSlice.reducer;
